export const ONBOARDING_API_ENDPOINT = process.env.REACT_APP_ONBOARDING_API_ENDPOINT
